import { createShortReferralUrl } from "util/common";
import {
  ReferralContainer,
  ReferralCopyButton,
  ReferralLabel,
  ReferralUrl,
} from "./referral-link.styled";

const ReferralLink = ({
  referralCode,
  handleCopy,
  className,
}: {
  referralCode: string;
  handleCopy: () => void;
  className?: string;
}) => (
  <ReferralContainer className={className}>
    <ReferralLabel>Invite your friends</ReferralLabel>
    <ReferralUrl>{createShortReferralUrl(referralCode)}</ReferralUrl>
    <ReferralCopyButton onClick={handleCopy}>Copy</ReferralCopyButton>
  </ReferralContainer>
);

export default ReferralLink;
